import { render, staticRenderFns } from "./DataObject.vue?vue&type=template&id=9a27836e&scoped=true&"
import script from "./DataObject.vue?vue&type=script&lang=js&"
export * from "./DataObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a27836e",
  null
  
)

export default component.exports